import { render, staticRenderFns } from "./SurveyTrigger.vue?vue&type=template&id=1227a25a&scoped=true&"
import script from "./SurveyTrigger.vue?vue&type=script&lang=js&"
export * from "./SurveyTrigger.vue?vue&type=script&lang=js&"
import style0 from "./SurveyTrigger.vue?vue&type=style&index=0&id=1227a25a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1227a25a",
  null
  
)

export default component.exports